export default "/kiban/_next/static/images/question-6b3e25794c315690e0420548a98f0114.png";